import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from "../../Endpoints/Endpoints";

const ViewCardGroup = () => {
  const [cardGroup, setCardGroup] = useState();
  const { cardgrpid } = useParams();

  useEffect(() => {
    const getCardGroupData = () => {
      axios({
        url: API.GET_CARDGROUP_BYID(cardgrpid),
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          setCardGroup(res.data[0]);
        })
        .catch((error) => {
          console.error('Error fetching card group:', error);
        });
    };

    if (cardgrpid) {
      getCardGroupData();
    }
  }, [cardgrpid]);

  const navigate = useNavigate();

  const deleteCardGroup = (cardgrpid) => {
    const deleteUrl = API.DELETE_CARDGROUP_API(cardgrpid);
    console.log('Deleting card group at:', deleteUrl); // Log the URL
    axios
      .delete(deleteUrl)
      .then(() => {
        alert("Card group deleted successfully");
        navigate("/cardgrouptable");
      })
      .catch((error) => {
        alert("Failed to delete card group");
        console.error('Error details:', error.response ? error.response.data : error.message);
      });
  };

  const goBack = () => {
    navigate("/cardgrouptable");
  };

  return (
    <div className="py-16 bg-[#d6d6d5] h-full">
      <div className="container px-6 m-auto text-gray-500 md:px-12 xl:px-0">
        <div className="grid gap-6 mx-auto md:w-3/6 lg:w-full lg:grid-cols-1">
          <div className="bg-white rounded-2xl shadow-xl px-8 py-12 sm:px-12 lg:px-8">
            <div className="mb-12 space-y-4">
              {cardGroup && (
                <div>
                  <h5 className="text-xl font-small text-red-700">Card Group ID: {cardGroup.cardgrpid}</h5>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col">
                      <span className="font-bold">Group Name</span>
                      <span>{cardGroup.grpname}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Group Symbol</span>
                      <span>{cardGroup.grpsymbol}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Name</span>
                      <span>{cardGroup.gamename}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Category</span>
                      <span>{cardGroup.gamecategory}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Challenges</span>
                      <span>{cardGroup.gamechallenges}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center p-4">
                    <button
                      className="bg-[#e64a32] text-white hover:bg-[#e64a32] font-bold py-2 px-4 rounded-full"
                      onClick={() => deleteCardGroup(cardGroup.cardgrpid)}
                    >
                      Delete
                    </button>
                    <div className="flex items-center justify-center p-3">
                      <button
                        className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full"
                        onClick={goBack}
                      >
                        &#8592; Go Back
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCardGroup;
